export default "__VITE_ASSET__bR1jDEC8__"